import { Link } from 'react-router-dom';
import { getFeaturedCourses } from '@/mocks/courses';

const courseImages: Record<string, string> = {
  'jp-lang-001': 'https://readdy.ai/api/search-image?query=Japanese%20language%20learning%20concept%20with%20minimalist%20design%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20atmosphere%2C%20soft%20shadows%2C%20scholarly%20vibe&width=600&height=400&seq=jp-lang-001&orientation=landscape',
  'jp-career-001': 'https://readdy.ai/api/search-image?query=Japanese%20business%20office%20environment%20with%20minimalist%20design%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20clean%20aesthetic%2C%20modern%20workspace&width=600&height=400&seq=jp-career-001&orientation=landscape',
  'jp-culture-001': 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20tea%20ceremony%20setup%20with%20minimalist%20design%2C%20warm%20natural%20lighting%2C%20serene%20atmosphere%2C%20tatami%20room%2C%20elegant%20composition&width=600&height=400&seq=jp-culture-001&orientation=landscape',
  'kr-lang-001': 'https://readdy.ai/api/search-image?query=Korean%20language%20learning%20concept%20with%20minimalist%20design%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20atmosphere%2C%20soft%20shadows%2C%20scholarly%20vibe&width=600&height=400&seq=kr-lang-001&orientation=landscape',
  'kr-career-001': 'https://readdy.ai/api/search-image?query=Korean%20business%20office%20environment%20with%20minimalist%20design%2C%20modern%20workspace%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20clean%20aesthetic&width=600&height=400&seq=kr-career-001&orientation=landscape',
  'kr-culture-001': 'https://readdy.ai/api/search-image?query=Korean%20pop%20culture%20and%20media%20concept%20with%20modern%20minimalist%20design%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20vibrant%20yet%20refined&width=600&height=400&seq=kr-culture-001&orientation=landscape',
};

export default function FeaturedCourses() {
  const featuredCourses = getFeaturedCourses();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精选推荐课程
            </h2>
            <p className="text-foreground-600 text-sm">
              由资深教研团队精心筛选的高品质课程，助你高效学习
            </p>
          </div>
          <Link
            to="/category/language"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {featuredCourses.map((course) => (
            <Link
              key={course.id}
              to={`/article/${course.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={courseImages[course.id] || courseImages['jp-lang-001']}
                  alt={course.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    course.zone === '一区'
                      ? 'bg-red-500/90 text-white'
                      : 'bg-amber-500/90 text-white'
                  }`}>
                    {course.zoneLabel}
                  </span>
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700">
                    {course.level}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs text-primary-600 font-medium bg-primary-50 px-2 py-0.5 rounded">
                    {course.category}
                  </span>
                </div>

                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {course.title}
                </h3>

                <p className="text-sm text-foreground-500 mb-4 line-clamp-2">
                  {course.shortDescription}
                </p>

                <div className="flex items-center gap-3 mb-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i> {course.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {course.readTime}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-background-200">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                    <span className="text-sm font-semibold text-foreground-900">{course.rating}</span>
                    <span className="text-xs text-foreground-500">({course.students.toLocaleString()})</span>
                  </div>
                  <span className="text-base font-bold text-primary-600">{course.price}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}